module.exports = __webpack_public_path__ + "img/001.c21b3a20.png";